import {
  fetchMailSnoozes,
  type SnoozeListResponse,
} from "@/lib/api/mailSnooze";
import type { ApiResult } from "@/lib/api/client";

const MIN_GAP_MS = 5_000;

const inflight = new Map<number, Promise<ApiResult<SnoozeListResponse>>>();
const recentOk = new Map<number, { at: number; data: SnoozeListResponse }>();

/** Une requête snooze.php par compte — évite ERR_INSUFFICIENT_RESOURCES. */
export function fetchMailSnoozesCoordinated(params: {
  accountId: number;
  folder?: string;
  force?: boolean;
}): Promise<ApiResult<SnoozeListResponse>> {
  const { accountId, folder, force = false } = params;
  const now = Date.now();

  if (!force) {
    const cached = recentOk.get(accountId);
    if (cached && now - cached.at < MIN_GAP_MS) {
      return Promise.resolve({ ok: true as const, data: cached.data });
    }

    const running = inflight.get(accountId);
    if (running) return running;
  }

  const promise = fetchMailSnoozes({ accountId, folder }).then((res) => {
    inflight.delete(accountId);
    if (res.ok) {
      recentOk.set(accountId, { at: Date.now(), data: res.data });
    }
    return res;
  });

  inflight.set(accountId, promise);
  return promise;
}

export function invalidateSnoozeFetchCache(accountId?: number): void {
  if (accountId == null) {
    recentOk.clear();
    return;
  }
  recentOk.delete(accountId);
}
